import Repository from './Repository'
import { AxiosResponse } from 'axios';
import {DichVu} from "@/models/dichVu";
import {NhomThucHienDichVu} from "@/models/nhomThucHienDichVu";
import {NhanVienKhoaPhong} from "@/models/nhanVienKhoaPhong";
import {NhanVienThucHien} from "@/models/nhanVienThucHien";
import {NhomThietBi} from "@/models/nhomThietBi";
import {ThietBi} from "@/models/thietBi";
import type {ThietBiHis} from "@/models/thietBiHis";
import {CaiDatChiTietThucHienDichVu} from "@/models/caiDatChiTietThucHienDichVu";
import {CaiDatChiTietThucHienDichVuUpdate} from "@/models/caiDatChiTietThucHienDichVuUpdate";
import {NguoiThucHien} from "@/models/nguoiThucHien";
import {ThietBiDichVu} from "@/models/thietBiDichVu";
import {NhanVienHoatDong} from "@/models/nhanVienHoatDong";
import {ChamCongNhanVien} from "@/models/chamCongNhanVien";

const resource = '/auth'

export default new class {
  xuatExcelChiaGio(ketQua: any): Promise<AxiosResponse<Blob>> {
    return Repository.post('/auth/chiaGio/xuatExcel', ketQua, {responseType:'blob'});
  }
  getLichSuChiaGio(khoa: number,ngay?: string,page=1,size=10): Promise<AxiosResponse<any>> {
    return Repository.get(`${resource}/chiaGio/lichSu/${khoa}`,{params:{ngay,page,size}});
  }
  getChiTietLichSu(khoa: number,id: number): Promise<AxiosResponse<any>> {
    return Repository.get(`${resource}/chiaGio/lichSu/${khoa}/${id}`);
  }
  xuatLaiLichSu(khoa: number,id: number): Promise<AxiosResponse<Blob>> {
    return Repository.get(`${resource}/chiaGio/lichSu/${khoa}/${id}/excel`,{responseType:'blob'});
  }
  xuatLichNhanVien(khoa:number,id:number,nhanVienId:number|null):Promise<AxiosResponse<Blob>> {
    return Repository.get(`${resource}/chiaGio/lichSu/${khoa}/${id}/nhanVien/excel`,{params:{nhanVienId:nhanVienId==null?undefined:nhanVienId},responseType:'blob'});
  }
  getDichVuKhoa(khoa: number): Promise<AxiosResponse<DichVu[]>> {
    return Repository.get(`${resource}/dichVu/khoaPhong/${khoa}`);
  }
  duyetDichVuKhoa(request: any): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/dichVu/duyetKhoa`, request);
  }
  suaDichVuKhoa(request: any): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/dichVu/suaKhoa`, request);
  }
  boDuyetDichVuKhoa(khoa: number, dichVuId: number): Promise<AxiosResponse<any>> {
    return Repository.delete(`${resource}/dichVu/khoaPhong/${khoa}/${dichVuId}`);
  }
  cauHinhHangLoat(loai: 'nhanVienKhoa' | 'nhanVienDichVu' | 'thietBiDichVu', request: any): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/cauHinh/${loai}`, request);
  }
  getNhomThietBiDichVu(khoa: number): Promise<AxiosResponse<any>> {
    return Repository.get(`${resource}/cauHinh/nhomThietBiDichVu/${khoa}`);
  }
  getPhanCongNhanVien(khoa: number): Promise<AxiosResponse<NguoiThucHien[]>> {
    return Repository.get(`${resource}/cauHinh/phanCongNhanVien/${khoa}`);
  }
  xoaTatCaCauHinh(khoa: number, loai: string): Promise<AxiosResponse<any>> {
    return Repository.delete(`${resource}/cauHinh/xoaTatCa/${khoa}/${loai}`);
  }
  getNhomDichVu(khoa: number): Promise<AxiosResponse<any[]>> {
    return Repository.get(`${resource}/nhomDichVu/${khoa}`);
  }
  luuNhomDichVu(request: any): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/nhomDichVu`,request);
  }
  xoaNhomDichVu(khoa: number, id: number): Promise<AxiosResponse<any>> {
    return Repository.delete(`${resource}/nhomDichVu/${khoa}/${id}`);
  }
  xoaNhomThietBiDichVu(id: number,khoa: number): Promise<AxiosResponse<any>> {
    return Repository.delete(`${resource}/cauHinh/nhomThietBiDichVu/${id}`,{params:{khoa}});
  }
  getListChiDinhVltl(timeFrom: number, timeTo: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/dsChiDinhVltl/${timeFrom}/${timeTo}`);
  }
  getListNhanVienVltl(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListNhanVien`);
  }
  dsDV(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListDichVu`);
  }
  dsCDAll(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListDVAll`);
  }
  createDichVu(dichVu: DichVu): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createDichVu`, dichVu);
  }
  createNhieuDichVu(danhSach: DichVu[]): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createNhieuDichVu`, danhSach);
  }
  chonCaNhomDichVu(nhomDichVuId: number, soThucHien: number, thoiGianNghi: number): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/dichVu/chonCaNhom`, {nhomDichVuId, soThucHien, thoiGianNghi});
  }
  capNhatCaNhomDichVu(nhomDichVuId: number, soThucHien: number, thoiGianNghi: number): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/dichVu/capNhatCaNhom`, {nhomDichVuId, soThucHien, thoiGianNghi});
  }
  updateDichVu(dichVu: DichVu): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/updateDichVu`, dichVu);
  }
  createNhomThucHienDV(nhomThucHienDichVu: NhomThucHienDichVu): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createNhomNhanVienThucHien`, nhomThucHienDichVu);
  }
  getListNhom(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListNhomNhanVienThucHien`);
  }
  getDeteleNhom(id: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteNhomNhanVienThucHien/${id}`);
  }
  createNhanVienKhoaPhong(nhanVienKhoaPhong: NhanVienKhoaPhong): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createNhanVienKhoaPhong`, nhanVienKhoaPhong);
  }
  getListNhanVienKhoaPhong(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListNhanVienKhoaPhong`);
  }
  deteleNhanVienKhoaPhong(id: number,khoa: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteNhanVienKhoaPhong/${id}`,{params:{khoa}});
  }
  getListKhoaPhong(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListKhoaPhong`);
  }
  getListNhanVienByIdKhoaPhong(idKhoaPhong: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListNhanVienByIdKhoaPhong/${idKhoaPhong}`);
  }
  createNhanVienThucHien(nhanVienThucHien: NhanVienThucHien): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createNhanVienThucHien`, nhanVienThucHien);
  }
  getListNhanVienThucHien(id: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListNhanVienThucHien/${id}`);
  }
  deteleNhanVienThucHien(id: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deteleNhanVienThucHien/${id}`);
  }
  createNhomThietBi(nhomThietBi: NhomThietBi): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createNhomThietBi`, nhomThietBi);
  }
  getListNhomThietBi(khoa=0): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListNhomThietBi`,{params:{khoa}});
  }
  deleteNhomThietBi(id: number,khoa: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteNhomThietBi/${id}`,{params:{khoa}});
  }
  createThietBi(thietBi: ThietBi): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createThietBi`, thietBi);
  }
  getDanhMucThietBi(): Promise<AxiosResponse<ThietBiHis[]>> {
    return Repository.get(`${resource}/thietBi/danhMuc`);
  }
  getThietBiTheoKhoa(id: number): Promise<AxiosResponse<ThietBi[]>> {
    return Repository.get(`${resource}/thietBi/khoaPhong/${id}`);
  }
  ganThietBiVaoKhoa(idKhoaPhong: number, idNhomThietBi: number, thietBiIds: number[]): Promise<AxiosResponse<any>> {
    return Repository.post(`${resource}/thietBi/ganVaoKhoa`, {idKhoaPhong, idNhomThietBi, thietBiIds});
  }
  getListThietBi(id: number,khoa: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListThietBi/${id}`,{params:{khoa}});
  }
  deleteThietBi(id: number,khoa: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteThietBi/${id}`,{params:{khoa}});
  }
  createCaiDatChiTietThucHienDV(caiDatChiTietThucHienDichVu: CaiDatChiTietThucHienDichVu): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createCaiDatChiTietThucHienDV`, caiDatChiTietThucHienDichVu);
  }
  getListCaiDatDV(): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListCaiDatDv`);
  }
  getListThucHienDV(time1, time2, idKhoaPhong): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/exportThucHienDV/${time1}/${time2}/${idKhoaPhong}`);
  }
  getListThucHienDV2(time, idKhoaPhong, nhanVienHoatDong : NhanVienHoatDong[]): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/exportThucHienDV2/${time}/${idKhoaPhong}`, nhanVienHoatDong);
  }
  getChamCongNhanVien(time: number, idKhoaPhong: number): Promise<AxiosResponse<ChamCongNhanVien[]>>{
    return Repository.get<ChamCongNhanVien[]>(`${resource}/chamCongNhanVien/${time}/${idKhoaPhong}`);
  }
  luuChamCongNhanVien(time: number, idKhoaPhong: number, danhSach: ChamCongNhanVien[]): Promise<AxiosResponse<ChamCongNhanVien[]>>{
    return Repository.post<ChamCongNhanVien[]>(`${resource}/chamCongNhanVien/${time}/${idKhoaPhong}`, danhSach);
  }
  chiaGioThucHien(time: number, idKhoaPhong: number): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/chiaGioThucHien/${time}/${idKhoaPhong}`, {});
  }
  deleteCaiDatDV(id: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteCaiDatDV/${id}`);
  }
  checkCaiDatDV(id: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/checkCaiDatDV/${id}`);
  }
  updateCaiDatDV(caiDatChiTietThucHienDichVu: CaiDatChiTietThucHienDichVu): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/updateCaiDatDV`, caiDatChiTietThucHienDichVu);
  }
  createNguoiThucHien(nguoiThucHien: NguoiThucHien): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createNguoiThucHien`, nguoiThucHien);
  }
  getListDVByIdNguoiThucHien(id: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/getListDVByIdNguoiThucHien/${id}`);
  }
  deleteDichVuThucHienById(id: number,khoa: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteDichVuThucHienById/${id}`,{params:{khoa}});
  }
  createThietBiDichVu(thietBiDichVu: ThietBiDichVu): Promise<AxiosResponse<any>>{
    return Repository.post<any>(`${resource}/createThietBiDichVu`, thietBiDichVu);
  }
  getListThietBiDichVu(idDichVu: number, idKhoaPhong: number): Promise<AxiosResponse<any>>{
    return Repository.get<any>(`${resource}/GetListThietBiDichVu/${idDichVu}/${idKhoaPhong}`);
  }
  deleteThietBiDichvu(id: number,khoa: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteThietBiDichvu/${id}`,{params:{khoa}});
  }
  deleteDichVu(id: number): Promise<AxiosResponse<any>>{
    return Repository.delete<any>(`${resource}/deleteDichVu/${id}`);
  }
}
